import axios from "axios";
import qs from "qs";
import decorateLoading from "./decorateLoading.js";
import success from "./success.js";
import { Toast } from "vant";
import envs from "../utils/envs.js"
import { getEnvName } from '../utils/env.js';

const handler = function (data) {
    return Promise.resolve(data);
};

export default function ({ decorateConfig }) {
    typeof decorateConfig === "function" || (decorateConfig = handler);
    /*
      config对象除了多一个loading属性, 其他都与和axios的config一致
      loading属性标识这个请求发起的时候是否需要显示loading
      */
    return async function (config) {
        config.method || (config.method = "GET");
        typeof config.timeout === "number" || (config.timeout = 600000);

        await getEnvName().then(envName => {
            let { tgsource } = qs.parse(location.search.slice(1));
            
            config.data = { ...(envs[envName]?.login.param() || {}), ...config.data };

            tgsource && (config.data['tgsource'] = tgsource)
        })

        if (typeof config.loading !== "boolean") {
            config.loading = true;
        }

        if (config.method === "GET" && !config.params && config.data) {
            config.params = config.data;
        }

        config.headers || (config.headers = {});

        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }

        if (
            config.data !== null &&
            typeof config.data === "object" &&
            config.headers["Content-Type"].indexOf(
                "application/x-www-form-urlencoded"
            ) > -1
        ) {
            config.data = qs.stringify(config.data);
        }

        const send = function () {
            return decorateConfig(config)
                .then(function (config) {
                    return axios(config);
                })
                .then(function (response) {
                    return { data: response.data, config };
                })
                .then(success, function (error) {
                    // 处理断网、超时
                    let message = error.message;

                    if (error.code === "ECONNABORTED") {
                        message = "请求超时, 请稍后再试!";
                    } else if (error.request && error.request.status == 0) {
                        message = "网络异常!";
                    } else if (message.indexOf("Request failed with status code") > -1) {
                        message = "请求发生错误, 请稍后重试!";
                    }
                    Toast(message)

                    error.message = message;

                    return Promise.reject(error);
                });
        };

        if (config.loading) {
            return decorateLoading(send());
        }

        return send();
    };
}
